export const reviews = [
  {
    stars: 5,
    content:
      "“Humming Homes changed my business...drastically. We’re so busy we had to hire another member of the team.”",
    reviewer: "RICHARD F.",
    role: "PLUMBER",
    area: "MIAMI"
  },
  {
    stars: 5,
    content:
      "“Would highly recommend! Their team is so knowledgeable and it’s great to get in front of quality customers every day.”",
    reviewer: "HOWARD S.",
    role: "GENERAL CONTRACTOR",
    area: "WESTCHESTER COUNTY"
  },
  {
    stars: 5,
    content:
      "“No more last-minute cancellations or customers who don’t know what they’re doing! With Humming Homes, you’re dealing with experts through-and-through.”",
    reviewer: "LYDIA A.",
    role: "CLEANER",
    area: "HAMPTONS"
  },
  {
    stars: 5,
    content:
      "“Humming Homes handles everything from billing, payments, literally everything! We just get to show up and do a great job. No more chasing customer invoices.”",
    reviewer: "PAUL G.",
    role: "LANDSCAPER",
    area: "FAIRFIELD COUNTY"
  }
];
